import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  Slide,
  Stack,
  TextField,
  Button,
  IconButton,
  DialogActions
} from "@mui/material";
import CelebrationIcon from "@mui/icons-material/Celebration";
import CakeIcon from "@mui/icons-material/Cake";
import NaturePeopleIcon from "@mui/icons-material/NaturePeople";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import GroupsIcon from "@mui/icons-material/Groups";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

// Album categories with prices and updated images
const initialAlbumData = [
  {
    title: "Wedding Album",
    category: "Wedding",
    img: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=600&q=80",
    desc: "Elegant wedding albums with luxury finish, lay-flat pages, and custom covers.",
    price: "₹8,000 - ₹25,000",
    details: "Wedding Album details...",
    varieties: [
      {
        img: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=600&q=80",
        model: "Velvet",
        size: "14x40",
        images: "100",
        pages: "40",
        price: "₹12,000"
      },
      {
        img: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80",
        model: "Glossy",
        size: "12x36",
        images: "80",
        pages: "36",
        price: "₹10,000"
      }
    ]
  },
  {
    title: "Birthday Album",
    category: "Birthday",
    img: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80",
    desc: "Fun and colorful birthday albums, perfect for kids and family celebrations.",
    price: "₹3,000 - ₹8,000",
    details: "Birthday Album details...",
    varieties: [
      {
        img: "",
        model: "Kids Theme",
        size: "8x12",
        images: "40",
        pages: "20",
        price: "₹3,000"
      }
    ]
  },
  {
    title: "Outdoor Album",
    category: "Outdoor",
    img: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80",
    desc: "Albums for outdoor shoots, travel, and adventure. Durable and stylish.",
    price: "₹5,000 - ₹15,000",
    details: "Outdoor Album details...",
    varieties: []
  },
  {
    title: "Classic Album",
    category: "Classic",
    img: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=600&q=80",
    desc: "Timeless classic albums for all occasions. Thick pages and elegant covers.",
    price: "₹4,000 - ₹12,000",
    details: "Classic Album details...",
    varieties: []
  },
  {
    title: "Pre-Wedding Album",
    category: "Pre-Wedding",
    img: "https://images.unsplash.com/photo-1465101178521-c1a4c8a0b8ee?auto=format&fit=crop&w=600&q=80",
    desc: "Romantic pre-wedding albums with creative themes and elegant layouts.",
    price: "₹7,000 - ₹20,000",
    details: "Pre-Wedding Album details...",
    varieties: []
  },
  {
    title: "Post-Wedding Album",
    category: "Post-Wedding",
    img: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=600&q=80",
    desc: "Celebrate your new journey with stylish post-wedding albums.",
    price: "₹6,000 - ₹18,000",
    details: "Post-Wedding Album details...",
    varieties: []
  }
];

const categoryIcons = {
  Wedding: <CelebrationIcon sx={{ color: "#d32f2f" }} />,
  Birthday: <CakeIcon sx={{ color: "#ff9800" }} />,
  Outdoor: <NaturePeopleIcon sx={{ color: "#388e3c" }} />,
  Classic: <FavoriteIcon sx={{ color: "#1976d2" }} />,
  "Pre-Wedding": <FavoriteBorderIcon sx={{ color: "#e91e63" }} />,
  "Post-Wedding": <FavoriteIcon sx={{ color: "#f06292" }} />,
  "Baby Shoot": <ChildCareIcon sx={{ color: "#ffb300" }} />,
  Meetings: <GroupsIcon sx={{ color: "#1976d2" }} />
};

const transition = (props) => <Slide direction="up" {...props} />;

function Albums() {
  const [open, setOpen] = useState(false);
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const [selectedAlbumIdx, setSelectedAlbumIdx] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const [albumDesc, setAlbumDesc] = useState("");
  const [descEditMode, setDescEditMode] = useState(false);

  // Album CRUD
  const [albumData, setAlbumData] = useState([]);
  const [editCardMode, setEditCardMode] = useState(false);
  const [editCardIdx, setEditCardIdx] = useState(null);
  const [editCardImg, setEditCardImg] = useState("");
  const [editCardTitle, setEditCardTitle] = useState("");
  const [editCardDesc, setEditCardDesc] = useState("");
  const [editCardDetails, setEditCardDetails] = useState("");
  const [deleteIdx, setDeleteIdx] = useState(null);

const [addAlbumMode, setAddAlbumMode] = useState(false);
const [newAlbumImg, setNewAlbumImg] = useState("");
const [newAlbumTitle, setNewAlbumTitle] = useState("");
const [newAlbumCategory, setNewAlbumCategory] = useState("");
const [newAlbumDesc, setNewAlbumDesc] = useState("");
const [newAlbumPrice, setNewAlbumPrice] = useState("");
const [newAlbumDetails, setNewAlbumDetails] = useState("");

  // Album Variety CRUD
  const [varietyPage, setVarietyPage] = useState(0); // current page index
  const VARIETIES_PER_PAGE = 5;
  const [editVarietyText, setEditVarietyText] = useState("");
  const [weddingVarieties, setWeddingVarieties] = useState([]);
  const [editVarietyMode, setEditVarietyMode] = useState(false);
  const [editVarietyIdx, setEditVarietyIdx] = useState(null);
  const [editVarietyImg, setEditVarietyImg] = useState("");
  const [editVarietyModel, setEditVarietyModel] = useState("");
  const [editVarietySize, setEditVarietySize] = useState("");
  const [editVarietyImages, setEditVarietyImages] = useState("");
  const [editVarietyPages, setEditVarietyPages] = useState("");
  const [editVarietyPrice, setEditVarietyPrice] = useState("");

  const clientMongoId = localStorage.getItem("clientMongoId");

  // Fetch albums from DB
  useEffect(() => {
    async function fetchAlbums() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`);
        setAlbumData(
          res.data.albums && res.data.albums.length >= 6
            ? res.data.albums
            : initialAlbumData.slice(0, 6)
        );
      } catch (err) {
        setAlbumData(initialAlbumData.slice(0, 6));
      }
    }
    fetchAlbums();
  }, [clientMongoId]);

  // Fetch album description from DB
  useEffect(() => {
    async function fetchAlbumDesc() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/album-description`);
        setAlbumDesc(res.data.albumDescription || "");
      } catch (err) {
        setAlbumDesc("Explore our variety of albums, categories, and prices");
      }
    }
    fetchAlbumDesc();
  }, [clientMongoId]);

  // Open album dialog
  const handleCardClick = (album, idx) => {
    setSelectedAlbum(album);
    setSelectedAlbumIdx(idx);
    setOpen(true);
    setShowMore(false);
    setWeddingVarieties(album.varieties || []);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedAlbum(null);
    setShowMore(false);
  };

  const handleMoreInfo = () => {
    setShowMore(true);
  };

  // Edit album card
  const handleEditCard = (idx) => {
    setEditCardIdx(idx);
    setEditCardImg(albumData[idx].img);
    setEditCardTitle(albumData[idx].title);
    setEditCardDesc(albumData[idx].desc);
    setEditCardDetails(albumData[idx].details);
    setEditCardMode(true);
  };

  // Save album card
  const handleSaveCard = async () => {
    if (editCardIdx === null) return;
    const updated = [...albumData];
    updated[editCardIdx] = {
      ...updated[editCardIdx],
      img: editCardImg,
      title: editCardTitle,
      desc: editCardDesc,
      details: editCardDetails
    };
    setAlbumData(updated);
    setEditCardMode(false);
    setEditCardIdx(null);

    try {
      await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`, {
        albums: updated
      });
      alert("Album card updated successfully!");
    } catch (err) {
      alert("Failed to update album card.");
    }
  };

  // Delete album card
  const handleDeleteCard = async () => {
    const updated = albumData.filter((_, i) => i !== deleteIdx);
    setAlbumData(updated);
    setDeleteIdx(null);
    try {
      await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`, {
        albums: updated
      });
      alert("Album deleted successfully!");
    } catch (err) {
      alert("Failed to delete album.");
    }
  };

  // Album variety handlers
 const handleEditVariety = (idx) => {
  setEditVarietyIdx(idx);
  const v = weddingVarieties[idx];
  setEditVarietyImg(v.img);
  setEditVarietyModel(v.model);
  setEditVarietySize(v.size);
  setEditVarietyImages(v.images);
  setEditVarietyPages(v.pages);
  setEditVarietyPrice(v.price);
  setEditVarietyText(
    `Model: ${v.model}\nSize: ${v.size}\nImages: ${v.images}\nPages: ${v.pages}\nPrice: ${v.price}`
  );
  setEditVarietyMode(true);
};

  const handleSaveVariety = async () => {
    const updatedVarieties = [...weddingVarieties];
    updatedVarieties[editVarietyIdx] = {
      img: editVarietyImg,
      model: editVarietyModel,
      size: editVarietySize,
      images: editVarietyImages,
      pages: editVarietyPages,
      price: editVarietyPrice
    };
    setWeddingVarieties(updatedVarieties);
    setEditVarietyMode(false);
    setEditVarietyIdx(null);

    // Also update the selected album's varieties in albumData
    const updatedAlbums = [...albumData];
    updatedAlbums[selectedAlbumIdx] = {
      ...updatedAlbums[selectedAlbumIdx],
      varieties: updatedVarieties
    };
    setAlbumData(updatedAlbums);
    try {
      await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`, {
        albums: updatedAlbums
      });
      alert("Variety updated successfully!");
    } catch (err) {
      alert("Failed to update variety.");
    }
  };

  // Add new variety
  const handleAddVariety = (idx) => {
    const updated = [...weddingVarieties];
    updated.splice(idx + 1, 0, {
      img: "",
      model: "",
      size: "",
      images: "",
      pages: "",
      price: ""
    });
    setWeddingVarieties(updated);
    setEditVarietyIdx(idx + 1);
    setEditVarietyImg("");
    setEditVarietyModel("");
    setEditVarietySize("");
    setEditVarietyImages("");
    setEditVarietyPages("");
    setEditVarietyPrice("");
    setEditVarietyMode(true);
  };

  // Delete variety
  const handleDeleteVariety = async (idx) => {
    const updated = weddingVarieties.filter((_, i) => i !== idx);
    setWeddingVarieties(updated);
    // Also update albumData
    const updatedAlbums = [...albumData];
    updatedAlbums[selectedAlbumIdx] = {
      ...updatedAlbums[selectedAlbumIdx],
      varieties: updated
    };
    setAlbumData(updatedAlbums);
    try {
      await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`, {
        albums: updatedAlbums
      });
      alert("Variety deleted successfully!");
    } catch (err) {
      alert("Failed to delete variety.");
    }
  };

  // Album description save
  const handleSaveAlbumDesc = async () => {
    if (!clientMongoId) return;
    try {
      await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/album-description`, {
        albumDescription: albumDesc,
      });
      setDescEditMode(false);
      alert("Album description saved!");
    } catch (err) {
      alert("Failed to save album description.");
    }
  };

  return (
    <Box sx={{ pt: 2, px: 2, bgcolor: "#f9f9f9", minHeight: "100vh" }}>
      <Typography
  gutterBottom
  variant="h5"
  component="div"
  sx={{
    fontWeight: 700,
    color: "#fff",
    textAlign: "center",
    background: "linear-gradient(90deg, #1976d2 60%, #64b5f6 100%)",
    borderRadius: 3,
    px: 2,
    py: 1,
    boxShadow: "0 2px 8px #1976d244",
    mb: 2,
    letterSpacing: 1.5,
      fontFamily: "Josefin Sans",height: 60, fontSize:40
  }}
>
        Albums
      </Typography>
      {/* Editable description below album text */}
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 5 }}>
        {descEditMode ? (
          <>
            <TextField
              multiline
              minRows={2}
              value={albumDesc}
              onChange={e => setAlbumDesc(e.target.value)}
              sx={{ width: 400, mr: 2 }}
            />
            <Button
              variant="contained"
              onClick={handleSaveAlbumDesc}
              sx={{ height: 40, fontFamily:"Josefin Sans", }}
            >
              Save
            </Button>
          </>
        ) : (
          <>
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                color: "#333",
                fontWeight: 500,
                 fontFamily:"Jost",
                mr: 2
              }}
            >
              {albumDesc}
            </Typography>
            <IconButton
              size="small"
              onClick={() => setDescEditMode(true)}
              sx={{ bgcolor: "#fff", boxShadow: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </>
        )}
      </Box>
      <Grid container spacing={10} justifyContent="center">
        {albumData.map((album, idx) => (
        <Grid item xs={12} sm={12} md={4} lg={4} key={album.title} sx={{ display: "flex", justifyContent: "center" }}>
  <Card
    sx={{
      width: 450, // Fixed width
      minWidth: 200,
      maxWidth: 800,
      height: 420, // Fixed height as before
      borderRadius: 4,
      boxShadow: 4,
      transition: "transform 0.3s",
      "&:hover": {
        transform: "scale(1.04)",
        boxShadow: 8,
        background: "linear-gradient(90deg,#e3f2fd 60%,#fff 100%)"
      },
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start"
    }}
    onClick={() => handleCardClick(album, idx)}
  >
              <CardActionArea sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={album.img}
                  alt={album.title}
                  sx={{
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    animation: "albumFade 2s"
                  }}
                />
                <CardContent
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    minHeight: 0,
                    overflow: "hidden",
                    pb: "0 !important"
                  }}
                >
                  <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} sx={{ mb: 1 }}>
                    {categoryIcons[album.category]}
                    <Chip sx={{ fontFamily:"Josefin Sans",background:"#1976d2",color:"white"}}label={album.category} color="primary" variant="outlined" />
                  </Stack>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      fontWeight: 700,
                      color: "#1976d2",
                      textAlign: "center",
                       fontFamily:"Josefin Sans",
                    }}
                  >
                    {album.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      textAlign: "center",
                      fontWeight: 500,
                      mb: 1,
                      fontFamily: "Jost",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      maxWidth: "100%",
                      fontSize: 14,
                      lineHeight: 1.5,
                      maxHeight: 48, // About 2-3 lines
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical"
                    }}
                  >
                    {album.desc}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      textAlign: "center",
                      color: "#388e3c",
                      fontWeight: 700,
                      fontSize: 16,
                       fontFamily:"Jost",
                    }}
                  >
                    {album.price}
                  </Typography>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 1 }}>
                    <IconButton
                      size="small"
                      onClick={e => {
                        e.stopPropagation();
                        setAddAlbumMode(true);
                        setNewAlbumImg("");
                        setNewAlbumTitle("");
                        setNewAlbumCategory("");
                        setNewAlbumDesc("");
                        setNewAlbumPrice("");
                        setNewAlbumDetails("");
                      }}
                      sx={{ bgcolor: "#fff", boxShadow: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
                    >
                      <AddIcon fontSize="small" sx={{ color: "#1976d2" }} />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={e => {
                        e.stopPropagation();
                        handleEditCard(idx);
                      }}
                      sx={{ bgcolor: "#fff", boxShadow: 1, "&:hover": { bgcolor: "#e3f2fd" } }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={e => {
                        e.stopPropagation();
                        setDeleteIdx(idx);
                      }}
                      sx={{ bgcolor: "#fff", boxShadow: 1, "&:hover": { bgcolor: "#fdecea" } }}
                    >
                      <DeleteIcon fontSize="small" sx={{ color: "#d32f2f" }} />
                    </IconButton>
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* Album Details Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={transition}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: 8,
            bgcolor: "#fff",
            animation: "albumDialogFade 1s"
          }
        }}
      >
        {selectedAlbum && (
          <>
            <DialogTitle
              sx={{
                fontWeight: 700,
                color: "#1976d2",
                textAlign: "center",
                fontSize: 28,
               fontFamily:"Josefin Sans",
                letterSpacing: 2
              }}
            >
              {selectedAlbum.title}
            </DialogTitle>
            <DialogContent>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img
                  src={selectedAlbum.img}
                  alt={selectedAlbum.title}
                  style={{
                    width: "100%",
                    maxWidth: 320,
                    height: 180,
                    objectFit: "cover",
                    borderRadius: 12,
                    marginBottom: 16,
                    boxShadow: "0 4px 16px rgba(25,118,210,0.10)",
                    animation: "albumFade 2s"
                  }}
                />
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                  {categoryIcons[selectedAlbum.category]}
                  <Chip label={selectedAlbum.category} color="primary" variant="outlined" />
                  <Chip label={selectedAlbum.price} color="success" variant="filled" />
                </Stack>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#333",
                    fontWeight: 500,
                    textAlign: "center",
                    whiteSpace: "pre-line",
                    mb: 2,
                    fontSize: 18,
                     fontFamily:"Jost",
                    animation: "albumTextAnim 1.2s"
                  }}
                >
                  {selectedAlbum.details}
                </Typography>
                {/* More Info Button at the bottom */}
                {!showMore && (
                  <Box sx={{ mt: 2, width: "100%", display: "flex", justifyContent: "center" }}>
                    <button
                      style={{
                        background: "#1976d2",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        padding: "8px 24px",
                        fontWeight: 700,
                        fontSize: 16,
                        cursor: "pointer",
                         fontFamily:"Josefin Sans",
                        boxShadow: "0 2px 8px rgba(25,118,210,0.10)",
                        transition: "background 0.2s"
                      }}
                      onClick={handleMoreInfo}
                    >
                      More Info
                    </button>
                  </Box>
                )}
                {showMore && (
                  <Box sx={{ mt: 3, width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Typography variant="h6" sx={{ color: "#1976d2", fontWeight: 700, mb: 2, fontFamily:"Josefin Sans", textAlign: "center" }}>
                      {selectedAlbum.category} Album Varieties & Prices
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "stretch",
                        gap: 3,
                        overflowX: "auto",
                        py: 2,
                        px: 1,
                        width: "100%",
                        background: "linear-gradient(90deg, #e3f2fd 0%, #fffde7 100%)",
                        borderRadius: 4,
                        boxShadow: "0 4px 24px #1976d222",
                        scrollbarWidth: "thin",
                        "&::-webkit-scrollbar": { height: 8 },
                        "&::-webkit-scrollbar-thumb": { bgcolor: "#bbdefb", borderRadius: 4 }
                      }}
                    >
                      {weddingVarieties
                        .slice(varietyPage * VARIETIES_PER_PAGE, (varietyPage + 1) * VARIETIES_PER_PAGE)
                        .map((variety, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              minWidth: 260,
                              maxWidth: 340,
                              minHeight: 320,
                              bgcolor: "#fff",
                              borderRadius: 4,
                              boxShadow: "0 4px 24px #1976d222",
                              p: 2,
                              textAlign: "center",
                              position: "relative",
                              transition: "transform 0.2s, box-shadow 0.2s",
                              "&:hover": {
                                transform: "scale(1.04)",
                                boxShadow: 8,
                                bgcolor: "#e3f2fd"
                              }
                            }}
                          >
                            <img
                              src={variety.img || "https://via.placeholder.com/260x140?text=Variety"}
                              alt={variety.model}
                              style={{
                                width: "100%",
                                maxWidth: 260,
                                height: 140,
                                objectFit: "cover",
                                borderRadius: 8,
                                marginBottom: 12,
                                boxShadow: "0 2px 8px rgba(25,118,210,0.10)"
                              }}
                            />
                            <IconButton
                              size="small"
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                bgcolor: "#fff",
                                boxShadow: 1,
                                "&:hover": { bgcolor: "#e3f2fd" }
                              }}
                              onClick={() => handleEditVariety(idx + varietyPage * VARIETIES_PER_PAGE)}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, fontFamily:"Josefin Sans", color: "#1976d2", mb: 1 }}>
                              {variety.model}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#333", fontWeight: 600, fontFamily:"Jost", }}>
                              Size: {variety.size}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#388e3c", fontWeight: 600,fontFamily:"Jost", }}>
                              Images: {variety.images}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#388e3c", fontWeight: 600,fontFamily:"Jost", }}>
                              Pages: {variety.pages}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#d32f2f", fontWeight: 700, mt: 1,fontFamily:"Jost", }}>
                              Price: {variety.price}
                            </Typography>
                            <Box sx={{ position: "absolute", bottom: 12, right: 12, display: "flex", gap: 1,fontFamily:"Jost", }}>
                              <IconButton
                                size="small"
                                sx={{
                                  bgcolor: "#fff",
                                  boxShadow: 1,
                                  "&:hover": { bgcolor: "#e3f2fd" }
                                }}
                                onClick={async () => {
                                  const globalIdx = idx + varietyPage * VARIETIES_PER_PAGE;
                                  const updated = [...weddingVarieties];
                                  updated.splice(globalIdx + 1, 0, { ...variety });
                                  setWeddingVarieties(updated);
                                  const updatedAlbums = [...albumData];
                                  updatedAlbums[selectedAlbumIdx] = {
                                    ...updatedAlbums[selectedAlbumIdx],
                                    varieties: updated
                                  };
                                  setAlbumData(updatedAlbums);
                                  try {
                                    await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`, {
                                      albums: updatedAlbums
                                    });
                                    alert("Variety added!");
                                  } catch (err) {
                                    alert("Failed to add variety.");
                                  }
                                }}
                              >
                                <AddIcon fontSize="small" sx={{ color: "#1976d2" }} />
                              </IconButton>
                              <IconButton
                                size="small"
                                sx={{
                                  bgcolor: "#fff",
                                  boxShadow: 1,
                                  "&:hover": { bgcolor: "#fdecea" }
                                }}
                                onClick={async () => {
                                  const globalIdx = idx + varietyPage * VARIETIES_PER_PAGE;
                                  const updated = weddingVarieties.filter((_, i) => i !== globalIdx);
                                  setWeddingVarieties(updated);
                                  const updatedAlbums = [...albumData];
                                  updatedAlbums[selectedAlbumIdx] = {
                                    ...updatedAlbums[selectedAlbumIdx],
                                    varieties: updated
                                  };
                                  setAlbumData(updatedAlbums);
                                  try {
                                    await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`, {
                                      albums: updatedAlbums
                                    });
                                    alert("Variety deleted!");
                                  } catch (err) {
                                    alert("Failed to delete variety.");
                                  }
                                }}
                              >
                                <DeleteIcon fontSize="small" sx={{ color: "#d32f2f" }} />
                              </IconButton>
                            </Box>
                          </Box>
                        ))}
                    </Box>
                    
                  </Box>
                )}
              </Box>
            </DialogContent>
          </>
        )}
      </Dialog>
      {/* Edit Dialog for a single card */}
      <Dialog open={editCardMode} onClose={() => setEditCardMode(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Album Card</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
            <img
              src={editCardImg}
              alt="Album"
              style={{
                width: 180,
                height: 120,
                objectFit: "cover",
                borderRadius: 8,
                marginBottom: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(25,118,210,0.10)"
              }}
              onClick={() => document.getElementById("edit-card-image-input").click()}
            />
            <input
              id="edit-card-image-input"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (ev) => setEditCardImg(ev.target.result);
                  reader.readAsDataURL(file);
                }
              }}
            />
            <Typography variant="caption" sx={{ color: "#1976d2", cursor: "pointer",fontFamily:"Jost", }} onClick={() => document.getElementById("edit-card-image-input").click()}>
              Click image to change
            </Typography>
          </Box>
          <TextField
            label="Title"
            fullWidth
            value={editCardTitle}
            onChange={e => setEditCardTitle(e.target.value)}
            sx={{ mb: 2, width: 400,fontFamily:"Jost", }}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            minRows={2}
            value={editCardDesc}
            onChange={e => setEditCardDesc(e.target.value)}
            sx={{ mb: 2, width: 400 }}
          />
          <TextField
            label="Details"
            fullWidth
            multiline
            minRows={4}
            value={editCardDetails}
            onChange={e => setEditCardDetails(e.target.value)}
            sx={{ width: 400 }}
          />
        </DialogContent>
        <DialogActions>
          <Button sx={{fontFamily:"Josefin Sans",}} onClick={() => setEditCardMode(false)}>Cancel</Button>
          <Button sx={{fontFamily:"Josefin Sans",}} variant="contained" onClick={handleSaveCard}>Save</Button>
        </DialogActions>
      </Dialog>
      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteIdx !== null} onClose={() => setDeleteIdx(null)}>
        <DialogTitle sx={{fontFamily:"Josefin Sans",}}>Are you sure you want to delete this album?</DialogTitle>
        <DialogActions>
          <Button sx={{fontFamily:"Josefin Sans",}} onClick={() => setDeleteIdx(null)}>No</Button>
          <Button sx={{fontFamily:"Josefin Sans",}}
            variant="contained"
            color="error"
            onClick={handleDeleteCard}
          >
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
      {/* Edit Dialog for wedding album variety */}
      <Dialog open={editVarietyMode} onClose={() => setEditVarietyMode(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Album Variety</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
            <img
              src={editVarietyImg}
              alt="Variety"
              style={{
                width: 180,
                height: 120,
                objectFit: "cover",
                borderRadius: 8,
                marginBottom: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(25,118,210,0.10)"
              }}
              onClick={() => document.getElementById("edit-variety-image-input").click()}
            />
            <input
              id="edit-variety-image-input"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (ev) => setEditVarietyImg(ev.target.result);
                  reader.readAsDataURL(file);
                }
              }}
            />
            <Typography variant="caption" sx={{ color: "#1976d2", cursor: "pointer" }} onClick={() => document.getElementById("edit-variety-image-input").click()}>
              Click image to change
            </Typography>
            <TextField
              label="All Variety Details"
              fullWidth
              multiline
              minRows={6}
              value={editVarietyText}
              onChange={e => setEditVarietyText(e.target.value)}
              sx={{ mt: 2, width: 400 }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditVarietyMode(false)}>Cancel</Button>
          <Button sx={{fontFamily:"Josefin Sans",}} variant="contained" onClick={async () => {
            // Parse the text back into fields
            const lines = editVarietyText.split("\n");
            let model = "", size = "", images = "", pages = "", price = "";
            lines.forEach(line => {
              if (line.startsWith("Model:")) model = line.replace("Model:", "").trim();
              if (line.startsWith("Size:")) size = line.replace("Size:", "").trim();
              if (line.startsWith("Images:")) images = line.replace("Images:", "").trim();
              if (line.startsWith("Pages:")) pages = line.replace("Pages:", "").trim();
              if (line.startsWith("Price:")) price = line.replace("Price:", "").trim();
            });
            const updatedVarieties = [...weddingVarieties];
            updatedVarieties[editVarietyIdx] = {
              img: editVarietyImg,
              model,
              size,
              images,
              pages,
              price
            };
            setWeddingVarieties(updatedVarieties);
            setEditVarietyMode(false);
            setEditVarietyIdx(null);

            // Update albumData and DB
            const updatedAlbums = [...albumData];
            updatedAlbums[selectedAlbumIdx] = {
              ...updatedAlbums[selectedAlbumIdx],
              varieties: updatedVarieties
            };
            setAlbumData(updatedAlbums);
            try {
              await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`, {
                albums: updatedAlbums
              });
              alert("Variety updated successfully!");
            } catch (err) {
              alert("Failed to update variety.");
            }
          }}>Save</Button>
        </DialogActions>
      </Dialog>
      {/* Add Album Dialog */}
      <Dialog open={addAlbumMode} onClose={() => setAddAlbumMode(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add New Album Card</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
            <img
              src={newAlbumImg || "https://via.placeholder.com/180x120?text=Album"}
              alt="Album"
              style={{
                width: 180,
                height: 120,
                objectFit: "cover",
                borderRadius: 8,
                marginBottom: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(25,118,210,0.10)"
              }}
              onClick={() => document.getElementById("add-album-image-input").click()}
            />
            <input
              id="add-album-image-input"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (ev) => setNewAlbumImg(ev.target.result);
                  reader.readAsDataURL(file);
                }
              }}
            />
            <Typography variant="caption" sx={{ color: "#1976d2", cursor: "pointer" }} onClick={() => document.getElementById("add-album-image-input").click()}>
              Click image to change
            </Typography>
          </Box>
          <TextField
            label="Title"
            fullWidth
            value={newAlbumTitle}
            onChange={e => setNewAlbumTitle(e.target.value)}
            sx={{ mb: 2, width: 400 }}
          />
          <TextField
            label="Category"
            fullWidth
            value={newAlbumCategory}
            onChange={e => setNewAlbumCategory(e.target.value)}
            sx={{ mb: 2, width: 400 }}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            minRows={2}
            value={newAlbumDesc}
            onChange={e => setNewAlbumDesc(e.target.value)}
            sx={{ mb: 2, width: 400 }}
          />
          <TextField
            label="Price"
            fullWidth
            value={newAlbumPrice}
            onChange={e => setNewAlbumPrice(e.target.value)}
            sx={{ mb: 2, width: 400 }}
          />
          <TextField
            label="Details"
            fullWidth
            multiline
            minRows={4}
            value={newAlbumDetails}
            onChange={e => setNewAlbumDetails(e.target.value)}
            sx={{ width: 400 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddAlbumMode(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={async () => {
              const updated = [
                ...albumData,
                {
                  img: newAlbumImg,
                  title: newAlbumTitle,
                  category: newAlbumCategory,
                  desc: newAlbumDesc,
                  price: newAlbumPrice,
                  details: newAlbumDetails,
                  varieties: [
                    {
                      img: "",
                      model: "",
                      size: "",
                      images: "",
                      pages: "",
                      price: ""
                    }
                  ] // <-- Add a default empty variety here
                }
              ];
              setAlbumData(updated);
              setAddAlbumMode(false);
              try {
                await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`, {
                  albums: updated
                });
                alert("Album added!");
              } catch (err) {
                alert("Failed to add album.");
              }
            }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
      {/* Animation styles */}
      <style>
        {`
          @keyframes albumFade {
            0% { opacity: 0; transform: scale(0.96);}
            100% { opacity: 1; transform: scale(1);}
          }
          @keyframes albumDialogFade {
            0% { opacity: 0; transform: translateY(40px);}
            100% { opacity: 1; transform: translateY(0);}
          }
          @keyframes albumTextAnim {
            0% { opacity: 0; transform: translateY(20px);}
            100% { opacity: 1; transform: translateY(0);}
          }
        `}
      </style>
    </Box>
  );
}

export default Albums;